<div (click)="openDetails(order.orderId, order.type)" class="limit-order-list-item">
  <div class="order-list-asset">
    <img class="image-size" [src]="order?.asset?.getLogo()" alt="order.image" />
    <div class="order-list-amount">
      <span class="order-amount-title">{{
        (order?.type === orderType.Buy ? "buy_cryptocoin" : "sell_cryptocoin")
        | translate
        : [
        order.asset?.getAssetGroupName() !== assetMetal
        ? order?.asset?.getSymbol()
        : order?.asset?.getName()
        ]
      }}</span>
      <span class="order-list-amount-value">
        @if (order?.type === orderType.Buy) {
          <order-fiat
						[fiatModel]="{
							amount: order.amount,
							id: order.fiat.getId(),
							currency: [order.fiat],
							hasDescription: false,
							description: '',
							precision: null
						}"></order-fiat>
        } @else {
          <order-tradable
						[tradableModel]="{
							amount: order.amount,
							id: order.asset?.getId(),
							addName: order.asset?.getAssetGroupName() !== assetMetal,
							hasDescription: false,
							description: ''
						}"></order-tradable>
        }
      </span>
    </div>
  </div>
  <span class="order-list-amount-price">
    <order-fiat
			[fiatModel]="{
				amount: order.price,
				id: order.fiat.getId(),
				currency: [order.fiat],
				hasDescription: true,
				description: 'limit_order_at_price',
				precision: order.fiatPrecision
			}"></order-fiat>
  </span>
</div>
